import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { cn } from '@/utils/cn';
import React from 'react';
import { Text, View } from 'react-native';
import { formatDateKorean } from '../utils/date';
const ACTIVITY_ITEM_HEIGHT = 52;
const ACTIVITY_ITEM_GAP = 20;
const DOT_SIZE = 10;
export default function ActivityItem({ activityDoneAt, title, visibleLine, isFirst, canceledAt, }) {
    const isCanceled = !!canceledAt;
    return (_jsx(View, { className: "h-[52px] flex-row justify-between", children: _jsxs(View, { className: "flex-row items-start gap-3", children: [_jsxs(View, { className: "h-5 items-center justify-center", children: [visibleLine && (_jsx(View, { className: "absolute left-1 top-[5px] w-[2px] bg-gray-25", style: {
                                bottom: -Math.abs(ACTIVITY_ITEM_HEIGHT + ACTIVITY_ITEM_GAP - DOT_SIZE),
                            } })), _jsx(View, { className: cn('h-[10px] w-[10px] rounded-[5px] border-[2px]', isFirst
                                ? 'border-brand-10 bg-brand-50'
                                : 'border-gray-20 bg-gray-50') })] }), _jsxs(View, { className: "gap-[6px]", children: [_jsx(Text, { className: cn('font-pretendard-regular text-[14px] leading-[20px]', isCanceled ? 'text-gray-30 line-through' : 'text-gray-50'), children: formatDateKorean(activityDoneAt === null || activityDoneAt === void 0 ? void 0 : activityDoneAt.value) }), _jsx(Text, { className: cn('font-pretendard-medium text-[18px] leading-[26px]', isCanceled ? 'text-gray-30 line-through' : 'text-gray-90'), children: title })] })] }) }));
}
function ActivityItemGap() {
    return _jsx(View, { className: "h-[20px]" });
}
ActivityItem.Gap = ActivityItemGap;
